'use client';

import { SessionProvider as NextAuthSessionProvider, useSession } from 'next-auth/react';
import { useEffect } from 'react';
import { setAuthToken, clearAuthToken } from '@/lib/tokenStore';

// Keeps the cached API access token in sync with the NextAuth session so the
// Axios interceptor never has to call getSession() (a /api/auth/session network
// round-trip) on every request. Imports only the dependency-free tokenStore —
// NOT authService — so this does not pull axios into every page's bundle.
function TokenSync() {
  const { data: session, status } = useSession();

  useEffect(() => {
    if (status === 'authenticated') {
      setAuthToken(session?.accessToken ?? null);
    } else if (status === 'unauthenticated') {
      clearAuthToken();
    }
  }, [status, session?.accessToken]);

  return null;
}

export default function SessionProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextAuthSessionProvider>
      <TokenSync />
      {children}
    </NextAuthSessionProvider>
  );
}
